// The Partnered Creator badge: gold, so it reads as earned rather than as
// another lime chip. Shown on a partner's code card, Partner tab,
// leaderboard row and public profile (users.thirdEra.partnered).
// compact keeps only the seal below sm, for tight rows.
import React from "react";
import { BadgeCheck } from "lucide-react";

const GOLD =
  "linear-gradient(135deg,#FFF1B8 0%,#F6CF5B 28%,#E0A526 55%,#F8DB7A 78%,#C98A14 100%)";

export default function PartneredBadge({
  compact = false,
  className = "",
}: {
  compact?: boolean;
  className?: string;
}) {
  return (
    <span
      className={`tw-relative tw-inline-flex tw-flex-shrink-0 tw-items-center tw-gap-1 tw-overflow-hidden tw-rounded-full tw-px-2.5 tw-py-1 tw-text-[11px] tw-font-extrabold tw-uppercase tw-leading-none tw-tracking-[0.06em] tw-text-[#4A3000] tw-shadow-[0_0_0_1px_rgba(255,236,170,0.9)_inset,0_2px_10px_rgba(224,165,38,0.45)] ${className}`}
      style={{ background: GOLD }}
    >
      {/* A soft highlight across the top, like light on metal. */}
      <span className="tw-pointer-events-none tw-absolute tw-inset-x-0 tw-top-0 tw-h-1/2 tw-bg-white/30" />
      <BadgeCheck
        size={13}
        strokeWidth={2.8}
        className="tw-relative tw-fill-[#4A3000] tw-text-[#F8DB7A]"
      />
      <span
        className={`tw-relative ${compact ? "tw-hidden sm:tw-inline" : ""}`}
      >
        Partnered creator
      </span>
    </span>
  );
}
